export default "__VITE_ASSET__484c4722__"